const formatCurrency = (value: number | string | undefined): string => {
  if (value === undefined || value === null) {
    return "$0.00";
  }
  const numericValue = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(numericValue)) {
    return "$0.00";
  }
  return numericValue.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const maxBorrowingAmountformat = (
  value: number | string | undefined
): string => {
  if (value === undefined || value === null) {
    return "0";
  }

  const numericValue = typeof value === "string" ? parseFloat(value) : value;

  if (isNaN(numericValue)) {
    return "0";
  }

  const roundedValue = Math.floor(numericValue); // Or Math.round() if you prefer rounding

  return roundedValue.toLocaleString("en-US");
};

export { formatCurrency, maxBorrowingAmountformat };
